import React, { useState, useEffect, createRef, useRef } from 'react';
import { Link } from 'react-router-dom';
import CardContainer from '../../components/card/card-container.jsx';
import CardPriceCategory from '../../components/card/card-price-category.jsx';
import LabelCategory from '../../components/label/label-category.jsx';
import LabelNumber from '../../components/label/label-number.jsx';
import Api from '../../api/global.service';
import { useAuth } from '../../components/content/auth.jsx';
import env from '../../environment.js';
import Swal from 'sweetalert2';

import Pagination from '../../components/pagination/pagination';
import SelectCiclo from '../../components/select/select-ciclo.jsx';
import SearchColumn from '../../components/search/search-column.jsx';
// import CheckboxList from '../../components/forms/checkbox-list.jsx';

import { subscribe, unsubscribe } from '../../components/events';
import LinkDownload from '../../components/link/link-download.jsx';
// import toggleIds from '../../utils/toggleIds.js';
import { useCoopConfig } from '../../components/content/coop-config.jsx';
import xlsx from 'json-as-xlsx';
import insertIf from '../../utils/insertIf.js';
import ModalRemanente from '../../components/modal/modal-remanente.jsx';
import ModalPrecioRemanente from '../../components/modal/modal-precio-remanente.jsx';
import getBackgroundColor from '../../utils/getBackgroundColor.js';
import getColor from '../../utils/getColor.js';
import LinkDownloadSpinner from '../../components/link/link-download-spinner.jsx';
import { Colors } from '../../constants/Colors.js';
import { BtnNuevo, BtnSecundario } from '../../nuup/componentes/Toolbar/ListToolbar.jsx';

const EntregasRemanenteList = () => {
  const auth = useAuth();
  const coopConfig = useCoopConfig();
  const [data, setData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [ciclo, setCiclo] = useState({});
  const [blocking, setBlocking] = useState(true);
  const dialog = createRef();
  const dialogRemanente = createRef();
  const [menuVisible, setMenuVisible] = useState(false);
  const [report, setReport] = useState('all');
  const [blockingReport, setBlockingReport] = useState(false);
  const [selectedData, setSelectedData] = useState();
  const [producto, setProducto] = useState('café');
  const [precioCategoria, setPrecioCategoria] = useState([]);
  const [renewRecibos, setRenewRecibos] = useState(true);
  const dataRef = useRef(data);

  // Keep dataRef in sync so event-subscribed callbacks never see stale data
  useEffect(() => {
    dataRef.current = data;
  }, [data]);

  useEffect(() => {
    if (coopConfig?.config?.cooperativa?.producto?.nombre) {
      setProducto(coopConfig.config.cooperativa.producto.nombre);
    }
  }, [coopConfig.config]);

  const columns = React.useMemo(
    () => [
      {
        Header: 'REMANENTE',
        columns: [
          {
            Header: '',
            accessor: 'x',
            minWidth: 20,
            Cell: ({ row }) => {
              const isRowChecked = selectedData?.id === row.original.id;
              return (
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="id"
                    style={{ width: 20, height: 20 }}
                    checked={isRowChecked}
                    onChange={e => {
                      if (isRowChecked) {
                        setSelectedData(null);
                      } else {
                        setSelectedData(row.original);
                      }
                    }}
                  />
                </div>
              );
            },
          },
          {
            Header: 'FOLIO REMANENTE',
            accessor: 'folio',
            sortable: true,
            minWidth: 50,
          },
          {
            Header: 'CATEGORÍA',
            accessor: 'cuenta_categoria',
            sortable: true,
            minWidth: 90,
            Cell: ({ value, row }) => {
              if (value != null) {
                return <LabelCategory label={value} color={row.original.cuenta_categoria_color}></LabelCategory>;
              } else {
                return value;
              }
            },
          },
          {
            Header: 'RECIBO',
            accessor: 'recibo_image',
            sortable: true,
            Cell: ({ value, row }) => {
              if (row.original.recibo_image) {
                return <LinkDownload url={`recibos/remanentes/${row.original.folio}`} label="Descargar" icon={env.images.icon.pdf} />;
              } else {
                return (
                  <a
                    href="#"
                    onClick={e => {
                      e.preventDefault();
                      window.location.reload();
                    }}
                    style={{ color: Colors.neutral_700 }}>
                    <LinkDownloadSpinner label="Generando" />
                  </a>
                );
              }
            },
          },
        ],
      },
      {
        Header: 'INFORMACIÓN DE PRODUCTOR',
        columns: [
          {
            Header: 'CLAVE / CÓDIGO',
            accessor: 'productor_codigo_tx',
            sortable: true,
            minWidth: 50,
            show: !!+coopConfig.config?.usa_codigo_tx,
          },
          {
            Header: 'NOMBRE PRODUCTOR',
            accessor: 'productor_nombre',
            sortable: true,
            minWidth: 50,
            Cell: ({ value, row }) => {
              if (row.original.productor_uuid != null) {
                return (
                  <Link
                    to={{
                      pathname: `/admin/cuentas/perfil/${row.original.productor_uuid}`,
                    }}
                    className="m-r-2"
                    style={{ color: '#789D16' }}>
                    <span>{value}</span>
                  </Link>
                );
              } else {
                return value;
              }
            },
          },
          {
            Header: 'LOCALIDAD',
            accessor: 'localidad',
            sortable: true,
            minWidth: 50,
          },
          {
            Header: 'REGIÓN',
            accessor: 'region',
            sortable: true,
            minWidth: 50,
          },
          {
            Header: 'CENTRO DE ACOPIO',
            accessor: 'centro_acopio',
            sortable: true,
            minWidth: 50,
          },
        ],
      },
      {
        Header: 'INFORMACIÓN DE PAGO',
        columns: [
          {
            Header: `PESO NETO (${coopConfig.hasAcopioUnitsExtra()
              ? coopConfig.acopioUnitsExtra()?.abreviacion_plural
              : coopConfig.acopioUnits()?.abreviacion_plural
              })`,
            accessor: 'peso_neto',
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return <LabelNumber value={value} digits={2}></LabelNumber>;
            },
          },
          {
            Header: `PRECIO A PRODUCTOR (${coopConfig.currency()?.symbol}/${coopConfig.hasAcopioUnitsExtra() ? coopConfig.acopioUnitsExtra()?.abreviacion : coopConfig.acopioUnits()?.abreviacion
              })`,
            accessor: 'precio_por_kg',
            sortable: true,
            minWidth: 50,
            Cell: ({ row }) => {
              const tipos = row.original.remanente_tipos || [];
              return tipos.map((tipo, index) => (
                <React.Fragment key={tipo.id || index}>
                  <div className="float-right mr-1">
                    <LabelNumber value={tipo.precio_por_kg} currencyLabel={coopConfig.currency()?.symbol} digits={2} />
                  </div>
                  {index < tipos.length - 1 && <span className="float-right mr-1"> | </span>}
                </React.Fragment>
              ));
            },
          },
          {
            Header: `IMPORTE TOTAL (${coopConfig.currency()?.symbol})`,
            accessor: 'cantidad_pago',
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return <LabelNumber value={value} currencyLabel={coopConfig.currency()?.symbol} digits={2}></LabelNumber>;
            },
          },
        ],
      },
    ],
    [producto, selectedData]
  );

  const searchColumns = React.useMemo(
    () => [
      { value: 0, target: '', label: 'TODO' },
      { value: 2, target: 'folio', label: 'FOLIO' },
      { value: 3, target: 'productor_codigo_tx', label: 'CODIGO' },
      { value: 3, target: 'productor_nombre', label: 'NOMBRE PRODUCTOR' },
      { value: 4, target: 'localidad', label: 'LOCALIDAD' },
      { value: 5, target: 'region', label: 'REGIÓN' },
      { value: 5, target: 'centro_acopio', label: 'CENTRO DE ACOPIO' },
      { value: 6, target: 'cuenta_categoria', label: 'CATEGORÍA' },
      {
        value: 7,
        target: 'peso_neto',
        label: `PESO NETO (${coopConfig.acopioUnits()?.abreviacion_plural})`,
      },
      { value: 8, target: 'precio_por_kg', label: 'PRECIO A PRODUCTOR' },
      {
        value: 9,
        target: 'cantidad_pago',
        label: `IMPORTE TOTAL (${coopConfig.currency()?.symbol})`,
      },
    ],
    []
  );

  useEffect(() => {
    subscribe('Precio::onSave', e => handleSave(e));
    subscribe('Remanente::onSave', e => handleSaveRemanente(e));

    return () => {
      unsubscribe('Precio::onSave');
      unsubscribe('Remanente::onSave');
    };
  }, []);

  useEffect(() => {
    ciclo.id && getPrecioCategoria();
    ciclo.id && getRemanentes();
  }, [ciclo]);

  const getRemanentes = async params => {
    setBlocking(true);
    const response = await Api.Acopio.search('remanente/recibos', {
      filter: [
        {
          column: 'id_cooperativa',
          operator: '=',
          value: auth.user.id_cooperativa,
        },
        {
          column: 'id_ciclo',
          operator: '=',
          value: params ? params.id_ciclo : ciclo.id,
        },
      ],
    });
    if (response.data.success == 1) {
      setData(response.data.data);
      setOriginalData(response.data.data);
      // if data, disabled the button
      response.data.data.length == 0 && setRenewRecibos(false);
      setBlocking(false);
    }
  };

  const getPrecioCategoria = async params => {
    if (auth.user.id_cooperativa) {
      const response = await Api.Acopio.search('remanente/precio_por_cooperativa', {
        filter: [
          {
            column: 'id_cooperativa',
            operator: '=',
            value: auth.user.id_cooperativa,
          },
          {
            column: 'id_ciclo',
            operator: '=',
            value: params ? params.id_ciclo : ciclo.id,
          },
        ],
      });
      const preciosLabel = response.data
        .filter(res => res.estatus == 'Vigente')
        .map(precio => {
          let label = env.colors.primary_500;
          let labelBg = env.colors.primary_50;
          precio.id_cat_certificacion == 31 && (label = env.colors.neutral_4); // Transicion 0
          precio.id_cat_certificacion == 31 && (labelBg = env.colors.neutral_3); // Transicion 0
          precio.id_cat_certificacion == 32 && (label = env.colors.secondary_400); // Transicion 1
          precio.id_cat_certificacion == 32 && (labelBg = env.colors.secondary_100); // Transicion 1
          precio.id_cat_certificacion == 33 && (label = env.colors.secondary_600); // Transicion 2
          precio.id_cat_certificacion == 26 && (labelBg = env.colors.neutral_1); // Transicion 3
          return {
            ...precio,
            label: label,
            labelBg: labelBg,
          };
        });
      setPrecioCategoria(preciosLabel);
    }
  };

  const onShowModal = (values = {}) => {
    const params = { id_ciclo: ciclo.id };
    dialog.current.show({ ...params, ...values });
  };

  const onShowModalEdit = (values = {}) => {
    dialogRemanente.current.show({ ...values });
  };

  // functions for SearchColumn component
  const setFilter = value => {
    setCiclo(value.target);
  };

  const setDataFilter = dataFilter => {
    dataFilter.length > 0 && setData(dataFilter);
  };

  const handleSave = async event => {
    Swal.fire({
      icon: 'success',
      title: '',
      text: `Se guardó con éxito el precio remanente.`,
    });
    const dataCoop = event.detail.dataCoop;
    // refresh category list prices
    await getPrecioCategoria(dataCoop);
    // refresh recibos remanentes only with data

    if (dataRef.current.length) {
      handleReceipts(dataCoop);
    }
  };

  const handleSaveRemanente = event => {
    Swal.fire({
      icon: 'success',
      title: '',
      text: `Se actualizó con éxito el pago remanente.`,
    });
    const data = event.detail;
    // refresh pagos list
    getRemanentes({ id_ciclo: data.id_ciclo });
    // Uncheck the selected row to force modal recreation on next open
    setSelectedData(null);
  };

  const handleDownloadReport = event => {
    event.preventDefault();
    // if (report !== 'all') {
    //   const filteredDataByDate = data.filter(item => item.fecha === date);
    //   exportarXlsx(filteredDataByDate, `remanentes_acopios_${ciclo.id}_deFecha_${date}`);
    // } else {
    exportarXlsx(data, `remanentes_acopios_${ciclo.id}`);
    // }
  };

  const handleReceipts = async params => {
    // data api call
    const response = await Api.Acopio.create('remanente/generar_recibos', params);
    if (response.status == 201) {
      // data create table here? call same endpoint refresh?
      Swal.fire({
        icon: 'success',
        title: '',
        text: response.data.data.length > 10 ? response.data.data : `Sus recibos se estan generando.`,
      });
      // data list
      getRemanentes(params);
    }
  };

  const exportarXlsx = (data, filename) => {
    const xlsData1 = [
      {
        sheet: 'RemanentesXproductor',
        columns: [
          { label: 'FOLIO REMANENTE', value: 'folio' },
          { label: 'CATEGORÍA', value: 'cuenta_categoria' },
          ...insertIf(!!+coopConfig.config?.usa_codigo_tx, {
            label: 'CLAVE / CODIGO',
            value: 'productor_codigo_tx',
          }),
          { label: 'NOMBRE PRODUCTOR', value: 'productor_nombre' },
          { label: 'LOCALIDAD', value: 'localidad' },
          { label: 'REGIÓN', value: 'region' },
          { label: 'CENTRO DE ACOPIO', value: 'centro_acopio' },
          {
            label: `PESO NETO (${coopConfig.acopioUnits()?.abreviacion_plural})`,
            value: row => +row.peso_neto,
            format: '0.00',
          },
          {
            label: `PRECIO A PRODUCTOR (${coopConfig.currency()?.symbol}/${coopConfig.acopioUnits()?.abreviacion})`,
            value: row => +row.precio_por_kg,
            format: `${coopConfig.currency()?.symbol}#,##0.00`,
          },
          {
            label: `IMPORTE TOTAL (${coopConfig.currency()?.symbol})`,
            value: row => +row.cantidad_pago,
            format: `${coopConfig.currency()?.symbol}#,##0.00`,
          },
        ],
        content: data,
      },
    ];

    const settings = {
      fileName: filename,
    };
    xlsx(xlsData1, settings);
  };

  return (
    <div>
      <div className="row justify-content-between">
        <SelectCiclo
          setFilter={evt => {
            setFilter(evt);
          }}
          acopio
        />
        {/* Download excel link */}
        <div className="col-2">
          {ciclo?.uuid && auth.hasPermission('ACOPIOS_ENTREGAS_X_PRODUCTOR_EXPORTAR') && (
            <div className="d-flex justify-content-end">
              {precioCategoria.length > 0 && (
                <Link to="#" onClick={() => setMenuVisible(!menuVisible)} className="m-r-2" style={{ color: '#789D16' }}>
                  <img src={env.images.icon.xls} className="pr-1" /> <span>Descargar Excel</span>
                </Link>
              )}
              {menuVisible === true && (
                <form className="dropdown-menu dropdown-menu dropdown-menu-right d-block p-10" style={{ top: 32 }}>
                  <div className="form-check pb-2">
                    <input
                      type="radio"
                      className="form-check-input"
                      name="report"
                      value="all"
                      checked={report === 'all'}
                      onClick={() => setReport('all')}
                      onChange={() => setReport('all')}
                    />
                    <label className="form-check-label" htmlFor="dropdownCheck">
                      Todos los registros
                    </label>
                  </div>
                  {blockingReport && (
                    <div className="d-flex justify-content-start float-right">
                      <div
                        className="spinner-border text-warning mr-2"
                        role="status"
                        aria-hidden="true"
                        style={{ height: 24, width: 24 }}></div>
                      <span className="mt-1">Descargando ...</span>
                    </div>
                  )}
                  {!blockingReport && (
                    <button type="submit" className="btn btn-sirio float-right" onClick={e => handleDownloadReport(e)}>
                      <i className="fa fa-download mr-2"></i> Descargar
                    </button>
                  )}
                </form>
              )}
            </div>
          )}
        </div>
      </div>

      <CardContainer height={'100%'}>
        <div className="row mb-4">
          {/* Category prices boxes */}
          <div className="col-12">
            {/* Current prices */}
            {precioCategoria.length > 0 ? (
              <>
                <div className="row mb-2 mr-2">
                  <div className="col-9">
                    <h4>Precio por categoría</h4>
                    <p>
                      Precio por{' '}
                      {coopConfig.hasAcopioUnitsExtra()
                        ? coopConfig.acopioUnitsExtra()?.abreviacion
                        : coopConfig.acopioUnits()?.abreviacion}
                      . para generar el pago remanente
                    </p>
                  </div>
                  <div className="col-3 text-right">
                    <BtnSecundario icon="fa-pen" onClick={() => onShowModal({ precioCategoria: precioCategoria })}>
                      Editar precio
                    </BtnSecundario>
                  </div>
                </div>
                <div className="row">
                  {precioCategoria.map(pc => (
                    <div className="col-3" key={pc.precio_id}>
                      <div className="mr-4">
                        <CardPriceCategory
                          height={92}
                          label={pc.categoria.replace('ransición ', '')}
                          value={pc.precio}
                          unit={`${coopConfig.currency()?.symbol}/${coopConfig.hasAcopioUnitsExtra()
                            ? coopConfig.acopioUnitsExtra()?.abreviacion
                            : coopConfig.acopioUnits()?.abreviacion
                            }`}
                          colors={{
                            bgCard: env.colors.neutral_2,
                            label: pc.label,
                            labelBg: pc.labelBg,
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
                <div className="row">
                  {/* boton generar recibos */}
                  <div className="col">
                    <BtnNuevo
                      icon="fa-save"
                      disabled={renewRecibos}
                      onClick={() => {
                        setRenewRecibos(true);
                        handleReceipts({
                          id_ciclo: ciclo.id,
                          id_cooperativa: auth.user.id_cooperativa,
                        });
                      }}>
                      Generar recibos
                    </BtnNuevo>
                  </div>
                  {/* boton para editar un pago específico */}
                  <div className="col text-right">
                    <BtnSecundario
                      show={auth.hasPermission('ACOPIOS_ENTREGAS_X_PRODUCTOR_NUEVO')}
                      icon="fa-pen"
                      onClick={() => onShowModalEdit()}
                      disabled={!selectedData}>
                      Editar pago remanente
                    </BtnSecundario>
                  </div>
                </div>
              </>
            ) : (
              <>
                {/* Register category prices */}
                <div className="row">
                  <div className="col-6">
                    <h4>Define un precio por categoría</h4>
                    <p>Éste es precio por {coopConfig.acopioUnits()?.abreviacion}. que se generará de remanente.</p>
                  </div>
                  <div className="col-6">
                    <BtnNuevo show={auth.hasPermission('ACOPIOS_PRECIO_X_COOPERATIVA_NUEVO')} onClick={() => onShowModal()}>
                      Registrar precio
                    </BtnNuevo>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>

        {/* table with pagination */}
        <div className="row">
          <div className="col-md-12">
            <SearchColumn data={originalData} columns={searchColumns} setDataFilter={evt => setDataFilter(evt)}></SearchColumn>
          </div>
        </div>
        <Pagination
          blocking={blocking}
          selected="id"
          columns={columns}
          data={data}
          pagination={true}
          fnBackgroundColor={getBackgroundColor}
          fnColor={getColor}></Pagination>

        <ModalRemanente key={selectedData?.id} ref={dialogRemanente} title="Editar pago remanente" data={selectedData}></ModalRemanente>
        <ModalPrecioRemanente ref={dialog} title="Registrar remanente"></ModalPrecioRemanente>
      </CardContainer>
    </div>
  );
};

export default EntregasRemanenteList;
